/* eslint-disable import-extensions/file-extension-required */
import { graphql } from 'react-relay';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import type {
	preloadTemplatesCollectionEligibleQuery$data,
	preloadTemplatesCollectionEligibleQuery$variables,
} from './__generated__/preloadTemplatesCollectionEligibleQuery.graphql';
import type { GraphQLError } from 'graphql';

const PreloadTemplatesCollectionEligibleQuery = graphql`
	query preloadTemplatesCollectionEligibleQuery {
		onboardingState(
			key: [
				"templates-collection:isTaggedForTemplatesCollectionExperiment"
				"templates-collection:isTemplatesSectionDismissed"
				"onboarding-state:introWorkflow"
				"onboarding-state:legacy"
				"onboarding-state:isFoundingAdmin"
				"onboarding-state:isSampleContentV2SpotlightVisible"
				"onboarding-state:landOnPath"
				"onboarding-state:teamSpaceCreated"
				"onboarding-state:isMoreActionsTourVisible"
				"onboarding-state:isMoreActionsHintVisible"
				"onboarding-state:improvedGetStartedPath"
				"onboarding-state:improvedGetStartedWhiteboardPath"
				"onboarding-state:nthUserGSPagePath"
				"onboarding-state:isRedactionsTourVisible"
				"onboarding-state:xflowSpaceCreated"
				"onboarding-state:templateOnboardingViewedTime"
				"onboarding-state:nthUserOnboardingCompletedTimestamp"
				"onboarding-state:nthUserOnboardingFlagViewed"
				"onboarding-state:nthUserOnboardingPageViewed"
				"onboarding-state:nthUserBannerDismissed"
			]
		) {
			key
			value
		}
		confluence_tenantContext {
			licensedProducts {
				licenseStatus
				productKey
			}
		}
		user: confluence_atlassianUser {
			id
			team
			confluence {
				hasPersonalSpace
				space {
					id
					key
				}
			}
		}
	}
`;

export const preloadTemplatesCollectionEligible = (): Promise<{
	data: preloadTemplatesCollectionEligibleQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> =>
	query<
		preloadTemplatesCollectionEligibleQuery$data,
		preloadTemplatesCollectionEligibleQuery$variables
	>({
		query: PreloadTemplatesCollectionEligibleQuery,
	});
